const azarSystemColor = {
  bg1: 'solidWhiteBg',
  bg2: 'solidWhiteModal',
  bg1DeepFixed: 'solidBlackBgFixed',
  bg1opacity0: 'solidWhiteBgOpacity0',
  bg2opacity0: 'solidWhiteModalOpacity0',
  content1: 'gray30',
  content2: 'gray60',
  content3: 'gray80',
  content4: 'gray100',
  content5: 'gray200',
  content6: 'gray300',
  content6Fixed: 'gray300Fixed',
  content7: 'gray400',
  content8: 'gray500',
  content9: 'gray600',
  content10: 'gray700',
  content11: 'gray800',
  content12: 'gray900',
  content12Fixed: 'gray900Fixed',
  contentBright: 'solidWhite',
  contentBrightFixed: 'solidWhiteFixed',
  contentDeep: 'solidBlack',
  contentDeepFixed: 'solidBlackFixed',
  contentInverse: 'solidBlackFixed',
  surface1: 'gray30',
  surface2: 'gray60',
  surface3: 'gray80',
  surface4: 'gray100',
  surface5: 'gray200',
  surface6: 'gray300',
  surface6Fixed: 'gray300Fixed',
  surface7: 'gray400',
  surface8: 'gray500',
  surface9: 'gray600',
  surface10: 'gray700',
  surface11: 'gray800',
  surface12: 'gray900',
  surface12Fixed: 'gray900Fixed',
  surfaceBright: 'solidWhite',
  surfaceBrightFixed: 'solidWhiteFixed',
  surfaceDeep: 'solidBlack',
  surfaceDeepFixed: 'solidBlackFixed',
  primary1: 'green500',
  primary2: 'green600',
  primary3: 'green700',
  primary4: 'green800',
  primary5: 'green850',
  primaryBright: 'green50',
  primaryDeep: 'green900',
  accentA1: 'red500',
  accentA2: 'red600',
  accentA3: 'red700',
  accentB1: 'orange500',
  accentB2: 'orange600',
  accentB3: 'orange700',
  accentC1: 'yellow500',
  accentC2: 'yellow600',
  accentC3: 'yellow700',
  accentD1: 'blue500',
  accentD2: 'blue600',
  accentD3: 'blue700',
  accentE1: 'indigo500',
  accentE2: 'indigo600',
  accentE3: 'indigo700',
  accentF1: 'purple500',
  accentF2: 'purple600',
  accentF3: 'purple700',
  accentG1: 'pink500',
  accentG2: 'pink600',
  accentG3: 'pink700',
  accentH1: 'green500',
  accentH2: 'green600',
  accentH3: 'green700',
  accentI1: 'cyan500',
  accentI2: 'cyan600',
  accentI3: 'cyan700',
  accentJ1: 'lime500',
  accentJ2: 'lime600',
  accentJ3: 'lime700',
  facebook1: 'facebook1',
  facebook2: 'facebook2',
  kakao1: 'kakao1',
  kakao2: 'kakao2',
  line1: 'line1',
  line2: 'line2',
  x1: 'x1',
  x2: 'x2',
};

export default azarSystemColor;
